import { INITIALIZE_STATE_FROM_STORAGE } from '~gatsby-theme-autonomy/redux/actions/types'
import storage from '~gatsby-theme-autonomy/services/storage'
import { logSentryError } from '~gatsby-theme-autonomy/services/sentry'
import { addReferralIdentifier } from '~gatsby-theme-autonomy/redux/actions/cart/add-referral-identifier'
import {
  loadCurrentCart,
  loadCart,
} from '~gatsby-theme-autonomy/redux/actions/cart/load-cart'
import { loadUser } from '~gatsby-theme-autonomy/redux/actions/user/load-user'
import { associateCartWithUser } from '~gatsby-theme-autonomy/redux/actions/cart/associate-cart-with-user'
import {
  handleCallback,
  getToken,
} from '~gatsby-theme-autonomy/redux/actions/auth'
import { getParam } from '~gatsby-theme-autonomy/utils/url'
import { setCookieFromParam } from '~gatsby-theme-autonomy/utils/cookies'
import settings from '~gatsby-theme-autonomy/services/settings'

export const initializeStateFromStorage = () => {
  const payload = {
    auth: {
      isLoggedIn: storage.getItem('chord-auth-logged-in'),
      token: storage.getItem('chord-auth-token'),
    },
    cart: {
      data: {
        number: storage.getItem('cart-number'),
        token: storage.getItem('cart-token'),
      },
    },
  }

  return {
    type: INITIALIZE_STATE_FROM_STORAGE,
    payload,
  }
}

export const initializeState = () => async (dispatch, getState) => {
  // Loading the user/auth during initialization is feature flagged in this
  // release as a lot of existing code is doing it manually and we do not want
  // to break that.
  const initalizeUser =
    !!process.env.GATSBY_OPTIONS_LOAD_USER_DURING_INITIALIZATION
  dispatch(initializeStateFromStorage())

  try {
    await dispatch(loadCart())
  } catch (error) {
    logSentryError(error, { source: 'initializeState' })
  }

  if (settings.auth.magic || settings.auth.stytch) {
    const authToken = getParam('magic_credential')
    if (authToken) {
      try {
        await dispatch(handleCallback())

        if (initalizeUser) {
          await dispatch(loadUser())
        }
      } catch (error) {
        logSentryError(error, { source: 'initializeState' })
      }
    } else if (initalizeUser) {
      try {
        await dispatch(getToken())
        await dispatch(loadUser())
      } catch (error) {
        logSentryError(error, { source: 'initializeState' })
      }
    }

    if (initalizeUser) {
      const { cart, user, auth } = getState()

      // We need to associate orders with user aggressively. If multiple
      // requests are fired for this, like during a login, there is a chance
      // that a 409 will happen, in which case, we will just reload the cart.
      if (user.data.id && !cart.data.userId && auth.isLoggedIn) {
        try {
          await dispatch(associateCartWithUser())
        } catch (error) {
          setTimeout(() => {
            dispatch(loadCurrentCart())
          }, 100)
        }
      }
    }
  }

  const referralIdentifier = getParam('ref')
  if (referralIdentifier) {
    try {
      dispatch(addReferralIdentifier(referralIdentifier))
    } catch (error) {
      logSentryError(error, { source: 'initializeState' })
    }
  }

  persistTrackingParams()
}

const persistTrackingParams = () => {
  setCookieFromParam('ir_click_id')
}
